/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { isCellularLogin } from "../../portalSettings";

/**
 * מסך הפתיחה "הרשמה או התחברות" - שער על **המסך הזה בלבד**.
 *
 * לריסיילר סלולרי אין שלב כזה: מסך ההתחברות שלו הוא נקודת הכניסה, וההרשמה מוצעת
 * מתוכו. לכן מי שנוחת על `/` מגיע ישירות ל-`/login`.
 *
 * **`children` ולא `Outlet`, וזה העיקר.** עד כה זו הייתה שכבת ניתוב שכל מסכי
 * הזרימה ישבו תחתיה, והיא הפנתה כל אחד מהם חזרה למסך ההתחברות הסלולרי. התוצאה
 * הייתה ששרשרת ההרשמה כולה - `/register`, אימות המייל, אימות הטלפון, יצירת
 * המשתמש, "כבר יש לכם חשבון" ו"ברוכים הבאים" - לא הייתה נגישה כלל לריסיילר
 * סלולרי: לחיצה על "הירשמו עכשיו" ניווטה ל-`/register`, השכבה זיהתה ריסיילר
 * סלולרי, והחזירה מיד לאותו מסך. כלפי חוץ זה נראה ככפתור מת.
 *
 * שער על מסלול אחד אינו יכול לחזור על זה: מסלול חדש אינו מצטרף אליו בשוגג. זו
 * אותה הכרעה בדיוק של `AllowFeatureByReseller`, ומאותה סיבה.
 *
 * ההכרעה עצמה היא `isCellularLogin` - אותה תשובה שנכתבת על `<html>` וקובעת את
 * ערכת העיצוב של כל שאר המסכים. אין כאן שאלה שנייה: הערכה קובעת איך המסכים
 * נראים, ולא אילו מסכים קיימים.
 */
const RedirectByReseller = ({ children }) => {
    const reseller = useSelector((state) => state.reseller.value);

    if (isCellularLogin(reseller)) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default RedirectByReseller;
